import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const ApiMApi = ApiCore(globalDomains.API_M_AFREECATV);
export default ApiMApi;
